import FreeForm from './FreeFormGrading';

export default FreeForm;
